<div class="card p-4 mb-4 text-white">
  
  <form [formGroup]="searchForm" (ngSubmit)="fetchData()">
    <div class="row g-3 align-items-end">
      
      <!-- از تاریخ -->
      <div class="col-12 col-md-4 col-lg-3 position-relative">
        <label class="form-label mb-1">از تاریخ</label>
        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="true"
          [dateFormat]="'jYYYY/jMM/jDD'"
        >
          <input formControlName="strSDate" class="form-control text-end" dir="ltr" />
        </ng-persian-datepicker>
      </div>

      <!-- تا تاریخ -->
      <div class="col-12 col-md-4 col-lg-3 position-relative">
        <label class="form-label mb-1">تا تاریخ</label>
        <ng-persian-datepicker
          [uiTheme]="'gray'"
          [timeEnable]="false"
          [dateGregorianFormat]="'YYYY/MM/DD'"
          [dateInitValue]="true"
          [dateFormat]="'jYYYY/jMM/jDD'">
          <input formControlName="strEDate" class="form-control text-end" dir="ltr" />
        </ng-persian-datepicker>
      </div>

      <!-- دکمه جستجو -->
      <div class="col-12 col-md-4 col-lg-2">
        <button class="btn btn-primary w-100" type="submit">جستجو</button>
      </div>

      <!-- دکمه اکسل -->
      <div class="col-12 col-md-4 col-lg-2">
        <button class="btn btn-success w-100" (click)="exportExcel()">اکسل</button>
      </div>
      
    </div>
  </form>

  <div class="table-responsive border border-secondary mt-3">
    <table class="table table-hover table-striped table-dark rounded-3 text-center align-middle" id="Export_Excel">
      <thead class="thead-dark">
        <tr >
          <th scope="col">#</th>
          <th scope="col">تاریخ</th>
          <th scope="col">روز</th>
          <th scope="col">ساعت شروع</th>
          <th scope="col">ساعت پایان</th>
          <th scope="col">مدت فعالیت</th>
          <th scope="col">تعداد استارت</th>
          <th scope="col">مصرف سوخت</th>
          <th scope="col">انرژی تولیدی</th>
          <th scope="col">راندمان سوخت به توان</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of reportPerformance; let i = index" class="f15">
          <td dir="ltr">{{ i + 1 | faNum }}</td>
          <td dir="ltr">{{ item.strDate | faNum }}</td>
          <td>{{ item.DayName }}</td>
          <td dir="ltr">{{ item.strSTime | faNum }}</td>
          <td dir="ltr">{{ item.strETime | faNum }}</td>
          <td>{{ item.strRunTimeSec | faNum }}</td>
          <td>{{ item.iRunCount | faNum }}</td>
          <td>{{ item.fFuelConsumed | faNum }}</td>
          <td>{{ item.fEnergyProduced | faNum }}</td>
          <td>
            <span class="badge" [ngClass]="{'bg-success': item.tiEfficiencyScore >= 80, 'bg-warning text-dark': item.tiEfficiencyScore >= 50 && item.tiEfficiencyScore < 80, 'bg-danger': item.tiEfficiencyScore < 50}">
              {{ item.tiEfficiencyScore | faNum }}
            </span>
          </td>
        </tr>
        
        <tr *ngIf="!reportPerformance || reportPerformance.length === 0">
          <td colspan="10" class="text-center text-muted py-4">
            رکوردی برای نمایش یافت نشد.
          </td>
        </tr>
      </tbody>
      <tfoot>
        <tr class="text-center">
          <th colspan="5">جمع کل</th>
          <td>{{ strTotalRunTimeSec | faNum }}</td>
          <td>{{ totalRunCount | faNum }}</td>
          <td>{{ totalFuelConsumed | faNum }}</td>
          <td>{{ totalEnergyProduced | faNum }}</td>
          <td></td>
        </tr>
      </tfoot>
    </table>
  </div>
</div>
